import {useConfirmDeleteDrugsCategory} from '@/modules/basic-data/categories/api'
import {DrugsCategorySummary} from '@/modules/basic-data/categories/components/drugs-category-drawer/drugs-category-summary'
import {DrugsCategoryDrawerTabsList} from '@/modules/basic-data/categories/components/drugs-category-drawer/tabs-list'
import {AboutTab} from '@/modules/basic-data/categories/components/drugs-category-drawer/tabs/about'
import {HistoryTab} from '@/modules/basic-data/categories/components/drugs-category-drawer/tabs/activity'
import {DrugsTab} from '@/modules/basic-data/categories/components/drugs-category-drawer/tabs/drugs'
import {getDrugsCategoryDrawerId} from '@/modules/basic-data/categories/components/drugs-category-drawer/util'
import {isDrugsCategoryDeletable} from '@/modules/basic-data/categories/functions'
import {drawer} from '@cypro/ui/components'
import {DrawerBody, DrawerFooter, DrawerHeader} from '@cypro/ui/components'
import {DeleteResourceButton} from '@cypro/ui/components/ui/delete-resource-button'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {Tooltip} from '@cypro/ui/components/ui/tooltip'
import {useCan} from '@/shared/hooks/use-permissions'
import {useDrugsCategoryContext} from '@/shared/contexts/drugs-category'
import {toaster} from '@cypro/ui/toaster'
import {Drawer, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function DrugsCategoryDrawer() {
  const {t} = useTranslate('common')
  const {t: tCategories} = useTranslate('categories')
  const {category, isSubcategory} = useDrugsCategoryContext()
  const deleteCategory = useConfirmDeleteDrugsCategory()
  const canManageBasicData = useCan('basic_data.manage')

  async function onDelete() {
    try {
      await deleteCategory({id: category.id})
      const drawerId = getDrugsCategoryDrawerId(category.id)
      drawer.close(drawerId)
      toaster.success({title: t('success'), description: t('resource_deleted_successfully')})
    } catch {}
  }

  const canDelete = isDrugsCategoryDeletable(category)
  const deleteBtn = <DeleteResourceButton onClick={onDelete} disabled={!canDelete} />

  return (
    <>
      <DrawerHeader>
        <Drawer.Title>{isSubcategory ? t('subcategory_details') : tCategories('category_details')}</Drawer.Title>
      </DrawerHeader>

      <DrawerBody>
        <DrugsCategorySummary />

        <Tabs.Root defaultValue="about" spaceY="5">
          <DrugsCategoryDrawerTabsList />

          <AboutTab />
          <DrugsTab />
          <HistoryTab />
        </Tabs.Root>
      </DrawerBody>

      {!isSubcategory && canManageBasicData && (
        <DrawerFooter display="flex" justifyContent="space-between">
          {!canDelete && (
            <Tooltip
              content={tCategories('cannot_delete_message', {
                substances: category?.drugCatalogItemsCategories?.length || 0,
              })}
            >
              {deleteBtn}
            </Tooltip>
          )}

          {canDelete && deleteBtn}

          <LinkButton
            to="/configuration/basic-data/categories/new"
            search={{categoryId: category.id}}
            colorPalette="cyan"
            data-e2e="edit-substance-category"
          >
            {t('edit')}
          </LinkButton>
        </DrawerFooter>
      )}
    </>
  )
}
